// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__V5cEE","selects":"Documents_selects__1bu0K"};